import Head from 'next/head';
import { useRouter } from 'next/router';
import { GlobalStyles } from '@spotify-internal/encore-web';
import '@spotify-internal/encore-web/css/encore-creator-dark-theme.css';
import '@spotify-internal/encore-web/css/fonts.css';
import '@spotify-internal/encore-web/css/encore-small-devices-layout-theme.css';
import '@spotify-internal/encore-web/css/encore-medium-devices-layout-theme.css';
import '@spotify-internal/encore-web/css/encore-text-styles.css';
import '@spotify-internal/encore-web/css/encore-creator-light-theme.css';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  const currentPath = useRouter().pathname;
  const pagesWithDarkTheme = ['/', '/unauthorized', '/noassociation'];
  const showDarkTheme = pagesWithDarkTheme.includes(currentPath);

  return (
    <>
      <Head>
        <link rel="shortcut icon" href="/favicon.ico?v=1" />
        <title>Catalog</title>
      </Head>
      <GlobalStyles />
      <div
        className={
          showDarkTheme
            ? 'encore-creator-dark-theme'
            : 'encore-creator-light-theme'
        }
      >
        {children}
      </div>
    </>
  );
};
